export const discoveryTour = {
    module: 'discovery',
    title: 'Discovery Tour',
    title_vi: 'Hướng dẫn Phát hiện',
    description: 'Trace scan results through staging review, classification and suggestions before accepting inventory changes.',
    description_vi: 'Theo dõi kết quả quét qua rà soát vùng chờ, phân loại và đề xuất trước khi tiếp nhận thay đổi vào danh mục.',
    estimated_duration_seconds: 329,
    revision: '2026-10-26.2',
    steps: [
        {
            step_id: 'explore_discovery_dashboard',
            navigate_to: '/admin/discovery/dashboard',
            target: '[data-tour-feature="tour-discovery-dashboard"]',
            wait_for: '[data-testid="discovery-dashboard-page"][data-tour-ready="true"]',
            title: 'Discovery Dashboard',
            title_vi: 'Tổng quan khám phá',
            description: 'This overview connects scans, discovered assets and review queues. Scan status tells you what the configured process has observed, not whether every data source has been covered. Follow the scan history and staged findings before deciding how the inventory should change.',
            description_vi: 'Tổng quan này liên kết lượt quét, tài sản được phát hiện và hàng đợi rà soát. Trạng thái quét cho biết quy trình đã cấu hình quan sát được gì, không xác nhận mọi nguồn dữ liệu đã được bao phủ. Theo dõi lịch sử quét và kết quả trong vùng chờ trước khi quyết định cách thay đổi danh mục.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'discovery_review_workflow',
            navigate_to: '/admin/discovery/dashboard',
            target: '[data-testid="discovery-dashboard-page"] .admin-quick-nav',
            wait_for: '[data-testid="discovery-dashboard-page"][data-tour-ready="true"]',
            title: 'Scans, Staging and Suggestions',
            title_vi: 'Lượt quét, vùng chờ và đề xuất',
            description: 'Discovery separates collecting scan results from reviewing them. Scans shows execution history; Staging holds discovered records for review; Classification Rules explains how findings are classified; Suggestions is the queue for proposed follow-up. Review the source and classification before accepting a discovered record into the inventory. This tour accepts nothing.',
            description_vi: 'Phát hiện tách việc thu thập kết quả quét khỏi việc rà soát. Lượt quét hiển thị lịch sử thực thi; Vùng chờ giữ bản ghi được phát hiện để rà soát; Quy tắc phân loại giải thích cách phân loại kết quả; Đề xuất là hàng đợi các việc tiếp theo được đề nghị. Rà soát nguồn và phân loại trước khi tiếp nhận bản ghi vào danh mục. Hướng dẫn này không tiếp nhận bản ghi nào.',
            position: 'bottom',
            duration_ms: 20000,
        },
        {
            step_id: 'discovery_recent_scans',
            navigate_to: '/admin/discovery/dashboard',
            target: '[data-testid="discovery-dashboard-page"] section[aria-label="Recent scans"]',
            wait_for: '[data-testid="discovery-dashboard-page"][data-tour-ready="true"]',
            title: 'Read Scan Outcomes Before Review',
            title_vi: 'Đọc kết quả quét trước khi rà soát',
            description: 'Recent scans show the scan type, execution status and progress rather than certifying that all data has been found. Use the scan identifier to investigate the run and then review its findings in Staging. When there are no scans, the empty message describes missing history, not a clean data estate.',
            description_vi: 'Các lượt quét gần đây hiển thị loại quét, trạng thái thực thi và tiến độ, không xác nhận rằng mọi dữ liệu đã được tìm thấy. Dùng mã lượt quét để tìm hiểu phiên chạy rồi rà soát kết quả tại Vùng chờ. Khi chưa có lượt quét, thông báo trống cho biết chưa có lịch sử, không khẳng định môi trường dữ liệu không có vấn đề.',
            position: 'bottom',
            duration_ms: 20000,
        },
        {
            step_id: 'explore_discovery_classification_rules',
            navigate_to: '/admin/discovery/classification-rules',
            target: '[data-testid="discovery-classification-rules-page"] .dm-filters',
            wait_for: '[data-testid="discovery-classification-rules-page"][data-tour-ready="true"]',
            title: 'Classification Rules',
            title_vi: 'Quy tắc phân loại',
            description: 'Compare taxonomy, resulting classification, priority, status and recorded effectiveness.',
            description_vi: 'So sánh hệ thống phân loại, kết quả phân loại, độ ưu tiên, trạng thái và hiệu quả đã ghi.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_classification_rules_register',
            navigate_to: '/admin/discovery/classification-rules',
            target: '[data-tour-register="explore_discovery_classification_rules_register"]',
            wait_for: '[data-testid="discovery-classification-rules-page"][data-tour-ready="true"]',
            title: 'Classification Rules — record decisions',
            title_vi: 'Quy tắc phân loại — quyết định theo bản ghi',
            description: 'Rule configuration describes intended matching; effectiveness describes observed suggestions. Inspect the relevant taxonomy before proposing a rule change; a high priority does not make its outcome an approved label.',
            description_vi: 'Cấu hình quy tắc mô tả cách khớp dự kiến; hiệu quả mô tả đề xuất đã quan sát. Xem hệ thống phân loại trước khi sửa quy tắc; ưu tiên cao không biến kết quả thành nhãn đã phê duyệt.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_dedup_rules',
            navigate_to: '/admin/discovery/dedup-rules',
            target: '[data-tour-feature="tour-discovery-dedup-rules"]',
            wait_for: '[data-testid="discovery-dedup-rules-page"][data-tour-ready="true"]',
            title: 'Dedup Rules',
            title_vi: 'Quy tắc trùng lặp',
            description: 'Read match type, threshold, priority and active/default state together. A deduplication rule identifies possible matches; it does not by itself establish which record should survive. Review the actual source records before any merge or promotion decision.',
            description_vi: 'Đọc cùng loại khớp, ngưỡng, ưu tiên và trạng thái hoạt động/mặc định. Quy tắc khử trùng lặp xác định khả năng trùng, không tự quyết định bản ghi nào được giữ. Rà soát bản ghi nguồn trước khi hợp nhất hoặc đưa vào danh mục.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_import_templates',
            navigate_to: '/admin/discovery/import-templates',
            target: '[data-tour-feature="tour-discovery-import-templates"]',
            wait_for: '[data-testid="discovery-import-templates-page"][data-tour-ready="true"]',
            title: 'Import Templates',
            title_vi: 'Mẫu nhập',
            description: 'Inspect file format and column mappings before reusing an import template. Mappings define how incoming fields will be interpreted; the presence of a template does not mean an import ran or passed validation. This walkthrough neither uploads a file nor starts an import.',
            description_vi: 'Xem định dạng tệp và ánh xạ cột trước khi dùng lại mẫu nhập. Ánh xạ xác định cách diễn giải trường đầu vào; có mẫu không có nghĩa việc nhập đã chạy hoặc hợp lệ. Hướng dẫn không tải tệp lên hoặc bắt đầu nhập.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_connectors',
            navigate_to: '/admin/discovery/connectors',
            target: '[data-tour-feature="discovery-cmdb-history"]',
            wait_for: '[data-testid="discovery-connectors-page"][data-tour-ready="true"]',
            title: 'Connector Management',
            title_vi: 'Quản lý kết nối',
            description: 'The CMDB and cloud sections show separate connector scan histories. Read connector name, status, progress and last sync before deciding which source needs investigation. Configuration needs its own permission; no scan or connection test is started here.',
            description_vi: 'Các phần CMDB và đám mây hiển thị lịch sử quét kết nối riêng. Đọc tên kết nối, trạng thái, tiến độ và lần đồng bộ cuối trước khi xác định nguồn cần điều tra. Cấu hình cần quyền riêng; bước này không quét hoặc thử kết nối.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_scans',
            navigate_to: '/admin/discovery/scans',
            target: '[data-testid="discovery-scans-page"] .dm-filters',
            wait_for: '[data-testid="discovery-scans-page"][data-tour-ready="true"]',
            title: 'Discovery Scans',
            title_vi: 'Quét khám phá',
            description: 'Compare scan type, execution status, progress and discovered count.',
            description_vi: 'So sánh loại quét, trạng thái thực thi, tiến độ và số mục phát hiện.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_scans_register',
            navigate_to: '/admin/discovery/scans',
            target: '[data-tour-register="explore_discovery_scans_register"]',
            wait_for: '[data-testid="discovery-scans-page"][data-tour-ready="true"]',
            title: 'Discovery Scans — record decisions',
            title_vi: 'Quét khám phá — quyết định theo bản ghi',
            description: 'Completion describes this run, not complete coverage of every source. Source configuration and adapter warnings belong to the creation workflow; inspect history and staging before deciding whether another scan is warranted.',
            description_vi: 'Hoàn thành mô tả lần chạy này, không phải bao phủ mọi nguồn. Cấu hình nguồn và cảnh báo bộ điều hợp nằm trong quy trình tạo; xem lịch sử và vùng chờ trước khi quyết định có cần quét tiếp.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_cycles',
            navigate_to: '/admin/discovery/cycles',
            target: '[data-tour-feature="tour-discovery-cycles"]',
            wait_for: '[data-testid="discovery-cycles-page"][data-tour-ready="true"]',
            title: 'Discovery Cycles',
            title_vi: 'Chu kỳ Khám phá',
            description: 'Read scope type, cadence, status and delta information for each operational discovery cycle. A cadence schedules collection; a delta describes differences observed by a run. Neither automatically approves changed inventory or resolves classification review.',
            description_vi: 'Đọc loại phạm vi, nhịp thực hiện, trạng thái và thông tin chênh lệch của kỳ khám phá vận hành. Nhịp thực hiện lên lịch thu thập; chênh lệch mô tả khác biệt quan sát từ lần chạy. Cả hai không tự phê duyệt danh mục thay đổi hoặc hoàn tất rà soát phân loại.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_staging',
            navigate_to: '/admin/discovery/staging',
            target: '[data-testid="discovery-staging-page"] .dm-filters',
            wait_for: '[data-testid="discovery-staging-page"][data-tour-ready="true"]',
            title: 'Staging Area',
            title_vi: 'Khu vực tạm',
            description: 'Read each discovered record’s source scan and promotion status before considering it inventory.',
            description_vi: 'Đọc lần quét nguồn và trạng thái đưa vào danh mục của từng mục phát hiện trước khi coi đó là danh mục chính thức.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_staging_register',
            navigate_to: '/admin/discovery/staging',
            target: '[data-tour-register="explore_discovery_staging_register"]',
            wait_for: '[data-testid="discovery-staging-page"][data-tour-ready="true"]',
            title: 'Staging Area — record decisions',
            title_vi: 'Khu vực tạm — quyết định theo bản ghi',
            description: 'Dedup status, where shown, identifies possible or exact matches needing review; a discovery result is not an approved system. Promotion, rejection and merging are separate decisions requiring the promotion grant.',
            description_vi: 'Trạng thái trùng lặp, khi hiển thị, chỉ ra khả năng hoặc khớp chính xác cần rà soát; kết quả khám phá chưa phải hệ thống đã phê duyệt. Đưa vào danh mục, từ chối và hợp nhất là quyết định riêng cần quyền tương ứng.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_suggestions',
            navigate_to: '/admin/discovery/suggestions',
            target: '[data-testid="discovery-suggestions-page"] .dm-filters',
            wait_for: '[data-testid="discovery-suggestions-page"][data-tour-ready="true"]',
            title: 'Suggestion Queue',
            title_vi: 'Hàng đợi đề xuất',
            description: 'Combine status, confidence band and taxonomy to find recommendations requiring review.',
            description_vi: 'Kết hợp trạng thái, khoảng độ tin cậy và hệ thống phân loại để tìm đề xuất cần rà soát.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_suggestions_register',
            navigate_to: '/admin/discovery/suggestions',
            target: '[data-tour-register="explore_discovery_suggestions_register"]',
            wait_for: '[data-testid="discovery-suggestions-page"][data-tour-ready="true"]',
            title: 'Suggestion Queue — record decisions',
            title_vi: 'Hàng đợi đề xuất — quyết định theo bản ghi',
            description: 'Compare suggested level, confidence, status and reviewer rather than treating confidence as approval. Accepting, modifying, rejecting or delegating a suggestion changes workflow and is not performed by this tour.',
            description_vi: 'So sánh cấp đề xuất, độ tin cậy, trạng thái và người rà soát thay vì coi độ tin cậy là phê duyệt. Chấp nhận, sửa, từ chối hoặc giao đề xuất làm thay đổi quy trình và không được thực hiện trong hướng dẫn.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_owner_review',
            navigate_to: '/admin/discovery/owner-review',
            target: '[data-tour-feature="tour-discovery-owner-review"]',
            wait_for: '[data-testid="discovery-owner-review-page"][data-tour-ready="true"]',
            title: 'Owner Review',
            title_vi: 'Xem xét Chủ sở hữu',
            description: 'Compare owner, task status and recorded decision in the review queue. The separate exceptions region records unresolved situations; an assigned owner is not a completed review. Follow the staged source record before making a promotion decision.',
            description_vi: 'So sánh người sở hữu, trạng thái nhiệm vụ và quyết định đã ghi trong hàng đợi rà soát. Phần ngoại lệ riêng ghi tình huống chưa giải quyết; đã giao chủ sở hữu không có nghĩa rà soát đã xong. Theo bản ghi nguồn trong vùng chờ trước khi quyết định đưa vào danh mục.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_analytics',
            navigate_to: '/admin/discovery/analytics',
            target: '[data-tour-feature="tour-discovery-analytics"]',
            wait_for: '[data-testid="discovery-analytics-page"][data-tour-ready="true"]',
            title: 'Suggestion Analytics',
            title_vi: 'Phân tích đề xuất',
            description: 'Read suggestion status and confidence distributions separately from rule acceptance rates. Acceptance reports what reviewers chose, not measured classification accuracy. Compare the relevant rule and period before using these figures to investigate configuration quality.',
            description_vi: 'Đọc phân bố trạng thái và độ tin cậy của đề xuất riêng với tỷ lệ chấp nhận theo quy tắc. Tỷ lệ chấp nhận cho biết lựa chọn của người rà soát, không đo độ chính xác phân loại. So sánh quy tắc và kỳ phù hợp trước khi dùng số liệu để điều tra chất lượng cấu hình.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_discovery_lineage',
            navigate_to: '/admin/discovery/lineage',
            target: '[data-tour-feature="discovery-lineage-context"]',
            wait_for: '[data-testid="discovery-lineage-page"][data-tour-ready="true"]',
            title: 'Classification Lineage',
            title_vi: 'Lịch sử Phân loại',
            description: 'Select a staged record to inspect its lineage from source scan through suggestion to proposed label. An unselected picker is not an empty lineage result: no record-specific read has run yet. The available rows identify linked records and timestamps; linking a record is a separate action.',
            description_vi: 'Chọn bản ghi trong vùng chờ để xem nguồn gốc từ lần quét qua đề xuất đến nhãn đề xuất. Chưa chọn trong bộ chọn không phải kết quả nguồn gốc trống: chưa thực hiện truy vấn cho bản ghi cụ thể. Các dòng có sẵn chỉ ra bản ghi liên kết và thời điểm; tạo liên kết là hành động riêng.',
            position: 'bottom',
            duration_ms: 19000,
        },
    ],
};
//# sourceMappingURL=discovery.js.map